import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { Invitee } from './types';

interface GetInvitesResponse {
  success: boolean;
  invites: Invitee[];
}

const getInvites: QueryFunction<
  GetInvitesResponse,
  ['/shared/invites', { status?: string } | undefined]
> = async ({ queryKey }) => {
  const [, params] = queryKey;
  if (isMockServices()) return await mock(_mockData);
  const authTokenHttp = await getCompatibleAuthTokenHttp();

  // Build query string if status parameter is provided
  const queryString = params?.status ? `?status=${params.status}` : '';
  const url = `/shared/invites${queryString}`;

  const response = await authTokenHttp<GetInvitesResponse>(url, {
    method: 'GET',
  });
  if (response.data) return response.data;
  throw new Error('Failed to fetch invites');
};

export default getInvites;

const _mockData: GetInvitesResponse = {
  success: true,
  invites: [
    {
      id: 'cm8nm5bke0000o10i7d0y6zbh2',
      email: 'john.doe2@email.com',
      status: 'PENDING',
      roles: [{ name: 'Tenant Admin', description: 'Tenant Admin' }],
      tenantId: 'mock-tenant-id',
      expiresAt: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000),
      createdAt: new Date(),
    },
  ],
};
